import type { NetworkProductRanking, NetworkProductRankingSelectionParams } from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkProductRanking = async (
  selection: NetworkProductRankingSelectionParams,
): Promise<NetworkProductRanking> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.cohortUnit) params.cohortUnit = selection.cohortUnit
  if (selection.cohortValue !== undefined) params.cohortValue = String(selection.cohortValue)
  if (selection.categoryIds?.length) params.categoryIds = selection.categoryIds.join(',')
  if (selection.indicator) params.indicator = selection.indicator
  if (selection.productReference) params.productReference = selection.productReference

  const response = await gozokiApiWithAuth.get<NetworkProductRanking>(
    '/stores/get-network-product-ranking',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
